export const TESTIMONIES_LIST_KEY = 'TESTIMONIES_LIST';
export const TESTIMONIES_ONE_KEY = 'TESTIMONIES_ONE_KEY';
